export default "<div class=\"backdrop\" [class.lightTheme]=\"lightTheme\" (click)=\"onClick()\" @fade></div>\n"